import { BuildClass, timer } from '../../../universal';
import { React, ReactDOM, _ } from '../../lib';
import { Modal, ModalAnchored } from './modal';
import { stubDiv } from './stubs';
export const HelpIcon = (props) => (React.createElement(HelpTooltip, { title: props.title, timeout: 200 },
    React.createElement("span", { tabIndex: -1, className: BuildClass(['ui5-help-icon', props.className]) },
        React.createElement("img", { alt: "Help", className: BuildClass(['inline', props.classNameIcon]), src: "/static/img/svg/small-help-icon.svg" }))));
export const HelpTooltip = (props) => {
    const element = React.useRef(stubDiv);
    const refHoverTimeout = React.useRef(null);
    const refDimensions = React.useRef({ width: 0, height: 0 });
    const refTestBox = React.useRef(stubDiv);
    const [visible, setVisible] = React.useState(false);
    const [, setInc] = React.useState(0);
    React.useEffect(() => {
        const el = refTestBox.current;
        if (!el) {
            return;
        }
        const box = el.getBoundingClientRect();
        const newSize = { width: box.width, height: box.height };
        if (!_.isEqual(newSize, refDimensions.current)) {
            refDimensions.current = { width: box.width, height: box.height };
            setInc(v => v + 1);
        }
    }, [refTestBox.current, props.title]);
    const evMouseOver = React.useCallback(() => {
        refHoverTimeout.current = timer(props.timeout ?? 500, () => {
            setVisible(true);
        });
    }, [refHoverTimeout.current, props.timeout, setVisible]);
    React.useEffect(() => {
        element.current?.addEventListener('mouseover', evMouseOver);
        return () => {
            element.current?.removeEventListener('mouseover', evMouseOver);
        };
    }, [element.current, evMouseOver]);
    const evMouseOut = React.useCallback(() => {
        if (refHoverTimeout.current) {
            clearTimeout(refHoverTimeout.current);
        }
        setVisible(false);
    }, [refHoverTimeout.current, setVisible]);
    React.useEffect(() => {
        element.current?.addEventListener('mouseout', evMouseOut);
        return () => {
            element.current?.removeEventListener('mouseout', evMouseOut);
        };
    }, [element.current, evMouseOut]);
    return (React.createElement(React.Fragment, null,
        React.cloneElement(props.children, { ref: element }),
        React.createElement(ModalAnchored, { mountElement: element.current, hidden: !visible, width: refDimensions.current.width, maxHeight: refDimensions.current.height, className: "ui5-help-tooltip", alignX: "center", flipByDefault: true },
            React.createElement("div", { className: "inner" }, props.title)),
        React.createElement(Modal, null,
            React.createElement("div", { className: "ui5-help-tooltip", ref: refTestBox },
                React.createElement("div", { className: "inner" }, props.title)))));
};
export const SimpleHelpTooltip = ({ children, tip, direction = 'top', offsetX = 0, offsetY = 0, }) => {
    const [isVisible, setIsVisible] = React.useState(false);
    const [position, setPosition] = React.useState({ top: 0, left: 0 });
    const triggerRef = React.useRef(stubDiv);
    const tooltipRef = React.useRef(stubDiv);
    React.useEffect(() => {
        if (isVisible && triggerRef.current && tooltipRef.current) {
            const triggerRect = triggerRef.current.getBoundingClientRect();
            const tooltipRect = tooltipRef.current.getBoundingClientRect();
            let top = 0;
            let left = 0;
            switch (direction) {
                case 'top':
                    top = triggerRect.top - tooltipRect.height - 10 + offsetY;
                    left = triggerRect.left + triggerRect.width / 2 + offsetX;
                    break;
                case 'bottom':
                    top = triggerRect.bottom + 10 + offsetY;
                    left = triggerRect.left + triggerRect.width / 2 + offsetX;
                    break;
                case 'left':
                    top = triggerRect.top + triggerRect.height / 2 + offsetY;
                    left = triggerRect.left - tooltipRect.width - 10 + offsetX;
                    break;
                case 'right':
                    top = triggerRect.top + triggerRect.height / 2 + offsetY;
                    left = triggerRect.right + 10 + offsetX;
                    break;
            }
            setPosition({
                top: top + window.scrollY,
                left: left + window.scrollX,
            });
        }
    }, [isVisible, direction, offsetX, offsetY]);
    const getTransform = () => {
        switch (direction) {
            case 'top':
            case 'bottom':
                return 'translateX(-50%)';
            case 'left':
            case 'right':
                return 'translateY(-50%)';
        }
    };
    const uiRoot = document.querySelector('.ui-root');
    if (!uiRoot) {
        throw new Error('ui-root not found');
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: triggerRef, onMouseEnter: () => {
                setIsVisible(true);
            }, onMouseLeave: () => {
                setIsVisible(false);
            } }, children),
        isVisible &&
            ReactDOM.createPortal(React.createElement("div", { className: "tailwind-wrapper" },
                React.createElement("div", { ref: tooltipRef, className: "absolute z-20 px-3 py-1 text-sm text-white bg-gray-800 rounded-md max-w-[200px] w-max break-words", style: {
                        top: `${position.top}px`,
                        left: `${position.left}px`,
                        transform: getTransform(),
                    } }, tip)), uiRoot)));
};
//# sourceMappingURL=help.js.map